import * as React from 'react';
import {connect} from 'react-redux';

import {change, formValueSelector, FieldArray, Field} from 'redux-form';

import {ConditionalCheckboxInput} from 'shells/form/conditional-checkbox-input';
import {Divider} from 'shells/layout/divider';
import {SpacerGroup} from 'shells/spacer/spacer-group';
import {Body} from 'shells/typography/body';

import {TagSelect} from '../../../../core/form/fields';

import {FORM_NAME} from '../create-rules-constants';

import {ShouldDedupeRadio} from './should-dedupe-radio-group';

const createRulesSelector = formValueSelector(FORM_NAME);

// @ts-expect-error
function mapStateToProps(state): StateProps {
    return {
        tagIds: createRulesSelector(state, 'tagIds'),
    };
}

// @ts-expect-error
function mapDispatchToProps(dispatch): DispatchProps {
    return {
        onClearTags: () => {
            dispatch(change(FORM_NAME, 'tagIds', []));
        },
    };
}

type StateProps = {
    tagIds: string[];
};

type DispatchProps = {
    onClearTags: () => void;
};

type Props = StateProps & DispatchProps;

export function CreateRulesFormAccountComponent(props: Props) {
    const [addTags, setAddTags] = React.useState<boolean>(
        Boolean(props.tagIds && props.tagIds.length)
    );
    const {onClearTags} = props;

    React.useEffect(() => {
        if (!addTags) {
            onClearTags();
        }
    }, [addTags, onClearTags]);

    return (
        <div>
            <div className='flex flex-dir-col mb-8'>
                <SpacerGroup mb={8}>
                    <Body>Would you like to find and update existing companies?</Body>
                </SpacerGroup>
                <Field name='shouldDedupe' component={ShouldDedupeRadio} size='big' />
            </div>
            <Divider variant='line--horizontal' spacing={16} />
            <SpacerGroup mb={16}>
                <Body>When this company is created…</Body>
            </SpacerGroup>
            <ConditionalCheckboxInput
                label='Add a tag'
                isLarge={true}
                checked={addTags}
                onChange={(checked) => setAddTags(checked)}
            >
                <FieldArray
                    name='tagIds'
                    component={TagSelect}
                    shouldAnd={true}
                    tagType='ACCOUNT'
                />
            </ConditionalCheckboxInput>
        </div>
    );
}

// @ts-expect-error
const connector = connect<Props, Record<any, any>, _, _, _, _>(mapStateToProps, mapDispatchToProps);
export const CreateRulesFormAccount = connector(CreateRulesFormAccountComponent);
